export default __webpack_public_path__ + "/images/dog.png";